import { render } from "./BasicInfoCard.vue?vue&type=template&id=61bdb490&scoped=true"
import script from "./BasicInfoCard.vue?vue&type=script&lang=js"
export * from "./BasicInfoCard.vue?vue&type=script&lang=js"

import "./BasicInfoCard.vue?vue&type=style&index=0&id=61bdb490&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bdb490"]])

export default __exports__